import { loadChartsOfAccountsMemoized } from "@odata/Data.utils";
import { IAccountEntity } from "@odata/GeneratedEntityTypes";

import { withPermissionContext } from "../../contexts/permissionContext/withPermissionContext";
import { toTuple } from "../../global.types";
import { IContextInitArgs } from "../../views/formView/FormStorage";
import {
    getAccountUsage,
    getMandatoryAccountsPromise,
    IAccountUsage,
    isMandatoryAccount
} from "./ChartOfAccounts.utils";
import ChartOfAccountsBaseFormView from "./ChartOfAccountsBaseFormView";


class ChartOfAccountsFormView extends ChartOfAccountsBaseFormView {
    getAccountUsageLoadPromise(args: IContextInitArgs): Promise<IAccountUsage> {
        if (!args.bindingContext.isNew()) {
            const parentId = args.bindingContext.getParent().getKey();
            const id = args.bindingContext.getKey();
            return getAccountUsage(parentId, id);
        }
        return null;
    }

    getChartOfAccountsPromise(_: IContextInitArgs): Promise<IAccountEntity[]> {
        const promise = loadChartsOfAccountsMemoized(this.props.storage.context);
        promise.then(chartsOfAccounts => this.props.storage.setCustomData({ chartOfAccounts: chartsOfAccounts }));
        return promise;
    }

    getAdditionalLoadPromise(args: IContextInitArgs) {
        return [
            this.getAccountUsageLoadPromise(args),
            this.getChartOfAccountsPromise(args),
            getMandatoryAccountsPromise(this.props.storage),
            ...super.getAdditionalLoadPromise(args)
        ];
    }

    setCustomAccountStorageData = async (): Promise<void> => {
        const [journalData] = await Promise.all(toTuple<[Promise<IAccountUsage>]>(this.props.storage.data.additionalResults));

        const isInvertibleWithPostedChildren = this.props.storage.data.entity.IsInvertible && journalData?.DescendantsHaveJournalEntries;
        const isMandatory = isMandatoryAccount(this.props.storage, this.props.storage.data.entity);
        const isPosted = journalData?.HasJournalEntries || isInvertibleWithPostedChildren;

        const isParentInvertible = this.props.storage.data.entity?.Parent?.IsInvertible;

        this.props.storage.setCustomData({
            journalData,
            isParentInvertible,
            isPosted,
            isMandatory
        });
    };

    async onAfterLoad(): Promise<void> {
        await this.setCustomAccountStorageData();
        return super.onAfterLoad();
    }
}

export default withPermissionContext(ChartOfAccountsFormView);